<template>
    <div class="localizations" v-if="currentLocalization">
      <div class="switcher" ref="switcher">
        <div class="" v-for="localization in groupsForType">
<!--           <label>{{ localizationName(localization) }}:</label> -->
          <div class="localization-switch">
            <ul>
              <template v-for="opt in localizationOpts(localization)">
                <li v-if="!itemLocalizations || hasLocalization(localization, opt.value)" class="switch-value" :class="{active: opt.value==currentLocalization[localization.join('|')]}" @click.prevent="currentLocalization[localization.join('|')]=opt.value">
                  <a href="" v-on:click.prevent="">
                    {{ opt.text }}
                    <span v-if="itemLocalizations && opt.value" v-on:click.prevent.stop="$emit('removeVariant', {localization, value: opt.value})" class="remove">&times;</span>
                  </a>
                </li>
              </template>
              <li v-if="hasMissingLocalization(localization)" class="add">
                <a href="" v-on:click.prevent="showAdd=localization.join('|')" class="add">+</a>
                <ul v-if="showAdd==localization.join('|')">
                  <template v-for="opt in localizationOpts(localization)">
                    <li v-if="canHaveLocalization(localization, opt.value)">
                      <a href="" v-on:click.prevent="showAdd=false; currentLocalization[localization.join('|')]=opt.value">
                        {{ opt.text }}
                      </a>
                    </li>
                  </template>
                </ul>
              </li>
            </ul>
          </div>
<!--           <FormSelect :options="localizationOpts(localization)" v-model="currentLocalization[localization.join('|')]" /> -->
        </div>
        <slot />
      </div>
    </div>
</template>

<script>
export default {
  props: ["modelValue", "fieldDesc", "itemLocalizations"],
  data: ()=>({
    showAdd: false,
  }),
  computed: {
    currentLocalization: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.emit("update:modelValue", value);
      },
    },
    groupsForType() {
      var result=[];
      var opts={};
      for(var field in this.fieldDesc) {
        var desc=this.fieldDesc[field];
        if (desc.localize)
          opts[desc.localize.join("|")]=true;
      }
      for(var localizeOpt in opts) {
        result.push(localizeOpt.split("|"));
        this.modelValue[localizeOpt]=this.modelValue[localizeOpt] || localizeOpt.replace(/[^|]/g, "");
      }

      return result;
    },
  },
  created() {
    if (!this.currentLocalization)
      this.currentLocalization={};
  },
  mounted() {
    this.hideClickListener=(event)=>{
      if (this.$refs.switcher?.contains(event.target))
        return;
      this.showAdd=false;
    };
    document.body.addEventListener("click", this.hideClickListener);
  },
  beforeUnmount() {
    document.body.removeEventListener("click", this.hideClickListener);
  },
  methods: {
    hasLocalization(type, value) {
      return this.itemLocalizations?.[type.join('|')]?.[value];
    },
    hasMissingLocalization(type) {
      for(var opt of this.localizationOpts(type))
        if (this.canHaveLocalization(type, opt.value))
          return true;
      return false;
    },
    canHaveLocalization(type, value) {
      if (this.hasLocalization(type, value))
        return false;
      return value && this.itemLocalizations && !this.itemLocalizations[type.join('|')]?.[value];
    },
    uppercaseFirst(value) {
      value=String(value);
      return value.substring(0, 1).toUpperCase()+value.substring(1);
    },
    localizationName(value) {
      if (this.stores.config.config.labels?.localization?.[value])
        return this.stores.config.config.labels?.localization?.[value];
      return this.uppercaseFirst(value);
    },
    localizationLabel(localization) {
      var authStore=this.stores.auth;
      var value=this.currentLocalization[localization] || null;
      for(var loc in authStore.localizations[localization] || []) {
        var item=authStore.localizations[localization][loc];
        if ((!value && item.default) || loc==value)
          return item.name
      }
      return null;
    },
    localizationOpts(localizations) {
      var authStore=this.stores.auth;
      var result=[[]];
      for(var locField of localizations) {
        var src=result;
        result=[];
        for(var resultItem of src) {
          for(var loc in authStore.localizations[locField] || []) {
            /* TODO */
            var item=authStore.localizations[locField][loc];
            result.push([
              ...resultItem, {
              value: item.default?'':loc,
              text: item.name
            }]);
          }
        }
      }
      return result.map(item=>({
        value: item.map(subitem=>subitem.value).join("|"),
        text: item.map(subitem=>subitem.text).join(" "),
      }));
    },
  },
}
</script>
